import { store } from '@betacrew/jars-flux';
import { all, put, takeLeading } from 'redux-saga/effects';
import { componentKey, setAssignPayerPaginationState, setLoadingState, setMemberRolesLoadingState, setMemberUserRoles, setMemberUsersList, setSelectedMembersUsersList } from './AssignMembersSlice';
import PayerDataService from '../../../../../services/PayerDataService';
import { PAGE_STATE } from '../../../constants/constants';
import { addNotifications } from '../../../toaster/ToasterPortalSlice';
import { TOASTER_VARIANT } from '../../../../components/toast/constants';
import RightsManagementDataService from '../../../../../services/RightsManagementDataService';
import { ASSIGN_MEMBER_LOADING_STATES } from './assignmemberstable/constants';
import General from '../../../../../libs/utility/General';


export const { getMemberUsersList, assignToUser, getMemberRoles } = {
    getMemberUsersList: (payload) => {
        return {
            type: "GET_MEMBER_USERS_LIST",
            payload
        }
    },

    assignToUser: (payload) => {
        return {
            type: "MEMBER_USERS/ASSIGN_TO_USER",
            payload
        }
    },

    getMemberRoles: (payload) => {
        return {
            type: "MEMBER_USERS/GET_MEMBER_USER_ROLES",
            payload
        }
    },
}

function* getMemberUsersListAsync(action) {
    try {
        yield put(setLoadingState({ state: ASSIGN_MEMBER_LOADING_STATES.GET_MEMBER_USERS_LIST_LOADING }))

        const { PageNumber, PageSize, FilterText, IsDesc, payerDetails = {} } = action.payload;

        const params = {
            PageNumber: PageNumber || 1,
            PageSize: PageSize || 10,
            FilterText: FilterText || "",
            IsDesc: IsDesc || false,
            payerId: payerDetails?.PayerDetailId || "",
        }

        const response = yield RightsManagementDataService.assignFormsUsers(params);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(setMemberUsersList(Data));
            yield put(setSelectedMembersUsersList([]));
            yield put(setAssignPayerPaginationState({totalRecords: General.extractPaginationTotalFromResponse(response.data)}))
        }
        else {
            yield put(addNotifications({ heading: "Failed to get the users list", message: Message }));
            yield put(setMemberUsersList([]));
            yield put(setSelectedMembersUsersList([]));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get the users list", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: ASSIGN_MEMBER_LOADING_STATES.GET_MEMBER_USERS_LIST_READY }))
    }

}

function* assignToUserAsync(action) {
    try {
        yield put(setLoadingState({ state: ASSIGN_MEMBER_LOADING_STATES.ASSIGN_TO_USER_LOADING }));

        const { selectedPayers = [], PayerDetailId, selectedMemberUsersList, onPopupCloseCb = () => {} } = action.payload;

        const payerIDs = [];
        const userIDs = [];

        if (selectedPayers.length) {
            selectedPayers.forEach(payer => {
                payerIDs.push(payer?.PayerDetailId)
            })
        } else {
            payerIDs.push(PayerDetailId);
        }

        if (selectedPayers.length || PayerDetailId) {
            selectedMemberUsersList.forEach(user => {
                userIDs.push(user?.UserId)
            })
        }

        const response = yield PayerDataService.assignPayers({ PayerIds: payerIDs, UserIds: userIDs });

        const { Message, Status } = response?.data;

        if (Status) {
            yield put(addNotifications({ heading: "Success", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
            onPopupCloseCb();
        } else {
            yield put(addNotifications({ heading: "Failed to assign to the user", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to assign to the user", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: ASSIGN_MEMBER_LOADING_STATES.ASSIGN_TO_USER_READY }))
    }
}

function* getMemberRolesAsync() {

    try {
        yield put(setMemberRolesLoadingState({ state: ASSIGN_MEMBER_LOADING_STATES.GET_MEMBER_ROLES_LOADING }));

        const response = yield RightsManagementDataService.getMemberRoles();
        if (response?.data.Status === 1) {
            yield put(setMemberUserRoles(response.data.Data.map(role => ({ label: role.Value, value: role.Key }))))
        } else {
            yield put(addNotifications({
                heading: "Error Fetching Member Roles",
                message: response?.data?.Message
            }));
        }

    } catch (error) {

        yield put(addNotifications({
            heading: "Error Fetching Member Roles",
            message: error?.response?.data?.Message
        }));
    } finally {
        yield put(setMemberRolesLoadingState({ state: ASSIGN_MEMBER_LOADING_STATES.GET_MEMBER_ROLES_READY }));
    }

}

function* rootSaga() {
    yield all([
        takeLeading(getMemberUsersList().type, getMemberUsersListAsync),
        takeLeading(assignToUser().type, assignToUserAsync),
        takeLeading(getMemberRoles().type, getMemberRolesAsync)
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);